import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult = objectOf({
  limit: anyOf(number, nullValidation),
  active_count: number,
  unchanged_active_step_ids: arrayOf(string),
});
